// const API_BASE_URL = "https://kr.camptratech.com/kr";
const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT;
const Base_Url = process.env.Base_Url;
const ClientId = process.env.clientId;
// const API_BASE_URL = "https://camptratech.com/krbackend";
// const API_BASE_URL = "http://localhost/custom_plugin";
// const API_BASE_URL = "https://kr.camptratech.com/kr";
// const API_BASE_URL = "https://kr.camptratech.com/kr";
// const API_BASE_URL = "https://kr.camptratech.com/stagingkr";

export { API_BASE_URL, Base_Url, ClientId };
